export const name = ({ theme: { dimensions } }) => ({
    maxWidth: dimensions.inputMaxWidth,
});
